import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BrizTvApp } from './BrizTvApp';
import { brizTvApps } from './brizTvApps';
import { openNewBrowserTab } from '../../../services/domService';
import { UseGetAuthLinkBrizTv } from '../../../hooks/UseGetAuthLinkBrizTv';
import { TextButton, TextButtonClassNames } from '../../commons/buttons/TextButton';
import { ReactComponent as ArrowDropdown } from '../../../assets/images/arrows/ArrowDefault.svg';

const REDIRECT_DELAY = 5;

export const BrizTvConnected = () => {
  const { t } = useTranslation();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_DELAY);
  const isActionCalled = useRef(false);
  const { getAuthLinkBrizTv, isLoadingGetAuthLinkBrizTv } = UseGetAuthLinkBrizTv();

  const handleBrizTv = async () => {
    if (isLoadingGetAuthLinkBrizTv) return;
    const link = await getAuthLinkBrizTv();
    openNewBrowserTab(link);
  };

  useEffect(() => {
    const endTime = Date.now() + REDIRECT_DELAY * 1000;

    const intervalId = setInterval(() => {
      const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setSecondsLeft(left);
      if (left === 0) {
        clearInterval(intervalId);
        if (!isActionCalled.current) {
          isActionCalled.current = true;
          handleBrizTv();
        }
      }
    }, 250);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleProceed = () => {
    if (!isActionCalled.current) {
      isActionCalled.current = true;
    }
    handleBrizTv();
  };

  return (
    <div className="success-container briz-tv-promotion">
      <h1>{t('success.brizTv.connectedOtt')}</h1>
      <div className="briz-tv-promotion__login-details connected-details">
        <p className="briz-tv-promotion__title">{t('success.brizTv.redirectToService')}</p>
        <div className="briz-tv-promotion__login-details__timer">00:{String(secondsLeft).padStart(2, '0')}</div>
        <hr />
        <div className="briz-tv-promotion__login-details__continue">
          <TextButton
            label={t('success.brizTv.orContinueNow')}
            handleClick={handleProceed}
            className={TextButtonClassNames.PrimaryActive}
            afterIcon={<ArrowDropdown className="arrow-dropdown" />}
          />
        </div>
      </div>
      <div className="briz-tv-promotion__apps-container">
        <div className="briz-tv-promotion__apps-container__available-apps-container">
          <p className="briz-tv-promotion__title">{t('success.brizTv.orDownloadApplication')}</p>
          <div className="briz-tv-promotion__apps-container__available-apps-container__apps">
            {brizTvApps.map((app) => {
              return <BrizTvApp {...app} key={app.description} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
